module.exports = __webpack_public_path__ + "img/changer-social-after.3ea8d00d.jpg";